import api, { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import * as Icons from "lucide-react";
import { toast } from "sonner";

const REPORTS = [
  { key: "progress", label: "Student Progress Report", icon: "TrendingUp", color: "#662D91" },
  { key: "attendance", label: "Attendance Report", icon: "CalendarCheck", color: "#22C55E" },
  { key: "points", label: "Story Points Report", icon: "Star", color: "#EAB308" },
  { key: "badges", label: "Badge Report", icon: "Medal", color: "#FC633B" },
];

export default function Reports() {
  const download = async (key) => {
    try {
      const res = await api.get(`/reports/${key}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = `${key}_report.csv`; a.click();
      URL.revokeObjectURL(url);
      toast.success("Report downloaded! 📊");
    } catch (e) { toast.error("Could not generate report."); }
  };

  return (
    <div className="space-y-5" data-testid="reports-page">
      <h2 className="font-head text-3xl text-csh-blue">Reports 📊</h2>
      <p className="text-muted-foreground">Export program data as CSV files.</p>
      <div className="grid gap-4 sm:grid-cols-2">
        {REPORTS.map((r) => {
          const I = Icons[r.icon];
          return (
            <div key={r.key} className="flex items-center gap-4 rounded-3xl bg-white p-5 shadow-sm border border-black/5" data-testid={`report-${r.key}`}>
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl" style={{ backgroundColor: r.color + "22" }}><I size={24} color={r.color} /></div>
              <div className="flex-1">
                <h3 className="font-head text-lg text-csh-blue">{r.label}</h3>
                <p className="text-xs text-muted-foreground">CSV export</p>
              </div>
              <Button onClick={() => download(r.key)} className="rounded-full gradient-purple text-white font-bold" data-testid={`download-${r.key}`}><Icons.Download size={16} /> Export</Button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
